// Interface for fund status workflow state
export interface FundStatusWorkflowState {
  fundStatusConfirmModalOpen: boolean;
  fundStatusConfirmAction?: string;
  fundStatusConfirmInvestor?: any;
  fundStatusConfirmAmount?: number;
  fundStatusConfirmResolver?: () => void;
}

export class FundStatusWorkflowHelper {
  static requiresFundStatusConfirmation(fundStatus: string): boolean {
    return fundStatus === 'UNDER_MANAGEMENT' || fundStatus === 'COMPLETE';
  }

  static openFundStatusConfirmModal(
    setState: (newState: Partial<FundStatusWorkflowState>) => void,
    action: string,
    investor: any,
    amount?: number,
    resolver?: () => void,
  ) {
    setState({
      fundStatusConfirmModalOpen: true,
      fundStatusConfirmAction: action,
      fundStatusConfirmInvestor: investor,
      fundStatusConfirmAmount: amount,
      fundStatusConfirmResolver: resolver,
    });
  }

  static closeFundStatusConfirmModal(
    setState: (newState: Partial<FundStatusWorkflowState>) => void,
  ) {
    setState({
      fundStatusConfirmModalOpen: false,
      fundStatusConfirmAction: undefined,
      fundStatusConfirmInvestor: undefined,
      fundStatusConfirmAmount: undefined,
      fundStatusConfirmResolver: undefined,
    });
  }

  static handleFundStatusConfirm(
    state: FundStatusWorkflowState,
    setState: (newState: Partial<FundStatusWorkflowState>) => void,
  ) {
    if (state.fundStatusConfirmResolver) {
      state.fundStatusConfirmResolver();
    }
    FundStatusWorkflowHelper.closeFundStatusConfirmModal(setState);
  }
}
